<template>
    <svg
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="60%"
      viewBox="0 0 200 200"
      enable-background="new 0 0 200 200"
      xml:space="preserve"
    >
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M113.000000,201.000000
                C105.312424,201.000000 97.624847,201.000000 89.468636,200.545593
                C89.000000,197.823090 89.000000,195.554977 89.000000,192.919617
                C86.122681,192.919617 83.711212,192.919617 80.935158,192.919617
                C80.935158,190.137680 80.935158,187.727234 80.935158,184.952011
                C78.155022,184.952011 75.744423,184.952011 72.968742,184.952011
                C72.968742,182.172852 72.968742,179.762390 72.968742,176.987305
                C70.193451,176.987305 67.786102,176.987305 64.888504,176.987305
                C64.888504,160.775238 64.888504,144.930344 64.888504,129.075806
                C61.902775,129.075806 59.416813,129.075806 56.962898,128.617950
                C56.994953,125.786835 56.994953,123.413559 56.994953,120.930016
                C53.840778,120.930016 51.385357,120.930016 48.964966,120.964996
                C48.999989,120.999985 49.070099,121.069885 49.037579,120.618698
                C48.980293,117.753044 48.955524,115.338577 49.402596,112.959373
                C60.149166,112.994629 70.423897,112.994629 80.774933,112.994629
                C80.774933,115.871468 80.774933,118.278809 80.774933,121.063042
                C78.141441,121.063042 75.726799,121.063042 73.220688,121.063042
                C73.220688,123.859512 73.220688,126.268639 73.220688,129.054626
                C75.849594,129.054626 78.264465,129.054626 80.783356,129.054626
                C80.783356,131.849869 80.783356,134.258789 80.783356,137.045837
                C78.168900,137.045837 75.746513,137.045837 73.218300,137.045837
                C73.218300,142.502350 73.218300,147.574142 73.218300,152.719910
                C81.375160,152.719910 89.314697,152.719910 97.136665,153.215668
                C97.106285,158.892868 97.193459,164.074295 96.798622,169.137726
                C93.907570,169.019730 91.498535,169.019730 89.312927,169.019730
                C89.312927,172.087173 89.312927,174.492783 89.312927,176.926712
                C92.104675,176.926712 94.583725,176.926712 97.033699,177.384827
                C97.004631,180.109848 97.004631,182.376724 97.004631,184.642639
                C99.925140,184.642639 102.435448,184.642639 104.672287,184.642639
                C104.672287,181.875992 104.672287,179.472244 104.672287,177.068726
                C101.869995,177.068726 99.395248,177.068726 96.957367,176.620758
                C97.039093,173.822159 97.083969,171.471527 97.573166,169.064789
                C100.272614,169.008682 102.527740,169.008682 104.752151,169.008682
                C104.752151,163.377197 104.752151,158.302521 104.752151,152.872009
                C102.044594,152.872009 99.582169,152.872009 97.064171,152.435852
                C97.032234,149.643555 97.055870,147.287430 97.042831,144.965683
                C97.006157,145.000076 96.937233,145.073288 97.408730,145.039230
                C105.565781,145.005173 113.251343,145.005173 121.073280,145.005173
                C121.073280,150.824493 121.073280,155.943604 120.615158,161.033661
                C117.890144,161.004623 115.623253,161.004623 113.357376,161.004623
                C113.357376,163.928833 113.357376,166.436783 113.357376,168.672256
                C116.124046,168.672256 118.527786,168.672256 120.931282,168.672256
                C120.931282,165.869873 120.931282,163.395157 121.389709,160.957336
                C124.113731,160.994247 126.379326,160.994247 128.924103,160.994247
                C128.924103,150.041473 128.924103,139.486252 129.396729,128.963058
                C137.562927,128.995102 145.256485,128.995102 153.287384,128.995102
                C153.287384,125.890732 153.287384,123.484047 153.287384,121.070038
                C156.119446,121.070038 158.594681,121.070038 161.034943,121.035011
                C160.999969,120.999985 160.929993,120.930000 160.962448,121.387283
                C160.994904,124.216461 160.994904,126.588356 160.994904,129.070007
                C164.160751,129.070007 166.615387,129.070007 169.033783,129.034973
                C168.997574,128.999939 168.924149,128.930893 168.959396,129.402740
                C168.994644,142.789307 168.994644,155.704025 168.994644,168.997055
                C163.533569,168.997055 158.457260,168.997055 152.844238,168.997055
                C152.844238,171.889908 152.844238,174.426819 152.844238,177.313416
                C149.874954,177.313416 147.464508,177.313416 144.699326,177.313416
                C144.699326,180.108536 144.699326,182.520355 144.699326,184.667892
                C141.906189,184.667892 139.497025,184.667892 136.722229,184.667892
                C136.722229,181.932419 136.722229,179.532776 136.722229,177.309204
                C128.610489,177.309204 120.886864,177.309204 113.000000,177.309204
                C113.000000,185.411713 113.000000,193.205856 113.000000,201.000000
            M161.000000,148.506134
                C161.000000,144.736801 161.000000,140.967468 161.000000,137.286194
                C152.688721,137.286194 144.950638,137.286194 137.287262,137.286194
                C137.287262,145.313446 137.287262,153.051559 137.287262,160.711700
                C145.315613,160.711700 153.053741,160.711700 161.000000,160.711700
                C161.000000,156.781464 161.000000,153.137680 161.000000,148.506134
            M73.000290,163.593689
                C73.000290,165.332458 73.000290,167.071228 73.000290,168.752991
                C75.964180,168.752991 78.350533,168.752991 80.791138,168.752991
                C80.791138,166.116470 80.791138,163.731323 80.791138,160.191910
                C77.879807,161.115601 75.441864,161.889114 73.000290,163.593689
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M113.466858,201.000000
                C113.000000,193.205856 113.000000,185.411713 113.000000,177.309204
                C120.886864,177.309204 128.610489,177.309204 136.722229,177.309204
                C136.722229,179.532776 136.722229,181.932419 136.722229,184.667892
                C139.497025,184.667892 141.906189,184.667892 144.699326,184.667892
                C144.699326,182.520355 144.699326,180.108536 144.699326,177.313416
                C147.464508,177.313416 149.874954,177.313416 152.844238,177.313416
                C152.844238,174.426819 152.844238,171.889908 152.844238,168.997055
                C158.457260,168.997055 163.533569,168.997055 168.994644,168.997055
                C168.994644,155.704025 168.994644,142.789307 169.418777,129.434784
                C172.108871,128.994995 174.374847,128.994995 177.165649,128.994995
                C177.165649,134.569656 177.165649,139.753540 177.165649,145.075699
                C182.821579,145.075699 187.945267,145.075699 193.034485,145.039001
                C193.000031,145.002289 192.930023,144.929916 192.962463,145.386978
                C192.994904,148.211914 192.994904,150.579773 192.994904,153.000000
                C196.115173,153.000000 198.557587,153.000000 201.000000,153.000000
                C201.000000,158.022095 201.000000,163.044189 200.552765,168.533142
                C197.716125,169.024399 195.326721,169.048798 192.966339,168.615082
                C192.995377,165.890091 192.995377,163.623199 192.995377,161.357391
                C190.074829,161.357391 187.564529,161.357391 185.327759,161.357391
                C185.327759,164.124069 185.327759,166.527802 185.327759,168.931213
                C188.130142,168.931213 190.604858,168.931213 193.042664,169.389648
                C193.005753,172.117645 193.005753,174.387207 193.005753,177.162659
                C182.076920,177.162659 171.563110,177.162659 160.704803,177.162659
                C160.704803,180.096313 160.704803,182.501450 160.704803,185.261063
                C157.924454,185.261063 155.513382,185.261063 152.924301,185.261063
                C152.924301,188.107986 152.924301,190.588470 152.960999,193.034485
                C152.997711,193.000031 153.070084,192.930023 152.613022,192.962463
                C149.788086,192.994904 147.420227,192.994904 145.000000,192.994904
                C145.000000,196.115173 145.000000,198.557587 145.000000,201.000000
                C142.629440,201.000000 140.258896,201.000000 137.444168,200.545593
                C137.000000,197.845886 137.000000,195.600586 137.000000,193.320801
                C134.084595,193.320801 131.581680,193.320801 129.000000,193.320801
                C129.000000,196.094238 129.000000,198.547119 129.000000,201.000000
                C123.977905,201.000000 118.955818,201.000000 113.466858,201.000000
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M1.000000,65.000000
                C1.000000,62.629444 1.000000,60.258884 1.468657,57.444164
                C20.272957,57.000000 38.608601,57.000000 57.000000,57.000000
                C57.000000,37.847950 57.000000,19.423975 57.000000,1.000000
                C59.370556,1.000000 61.741116,1.000000 64.555832,1.468645
                C65.000000,9.609268 65.000000,17.281246 65.000000,25.290627
                C68.127480,25.290627 70.524803,25.290627 73.073425,25.290627
                C73.073425,28.120394 73.073425,30.591629 72.615280,33.033752
                C69.890244,33.004639 67.623344,33.004639 65.357300,33.004639
                C65.357300,35.925072 65.357300,38.435406 65.357300,40.672321
                C68.123917,40.672321 70.527672,40.672321 72.931427,40.672321
                C72.931427,37.870018 72.931427,35.395309 73.388794,32.957417
                C76.116829,32.994228 78.387497,32.994228 81.019211,32.994228
                C81.019211,30.185629 81.019211,27.778637 81.019211,25.190651
                C83.784874,25.190651 86.182449,25.190651 89.075943,25.190651
                C89.075943,33.254177 89.075943,41.161652 88.616562,49.037071
                C85.884232,49.005013 83.611275,49.005013 80.963409,49.005013
                C80.963409,54.489151 80.963409,59.567730 80.963409,65.139221
                C62.082561,65.139221 43.578465,65.139221 24.719526,65.139221
                C24.719526,68.068115 24.719526,70.480934 24.719526,72.867256
                C21.930326,72.989967 19.512424,73.096344 17.069153,73.203835
                C17.069153,76.107552 17.069153,78.591743 16.599121,81.040665
                C11.086061,81.003601 6.043030,81.001801 1.000000,81.000000
                C1.000000,78.629440 1.000000,76.258888 1.454401,73.444168
                C4.154115,73.000000 6.399427,73.000000 8.679218,73.000000
                C8.679218,70.086998 8.679218,67.582481 8.679218,65.000000
                C5.905774,65.000000 3.452887,65.000000 1.000000,65.000000
            M65.000290,51.593674
                C65.000290,53.332443 65.000290,55.071217 65.000290,56.752991
                C67.964172,56.752991 70.350525,56.752991 72.791145,56.752991
                C72.791145,54.116486 72.791145,51.731331 72.791145,48.191891
                C69.879814,49.115589 67.441864,49.889091 65.000290,51.593674
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M73.073425,33.062866
                C73.073425,30.591629 73.073425,28.120394 73.073425,25.290627
                C70.524803,25.290627 68.127480,25.290627 65.000000,25.290627
                C65.000000,17.281246 65.000000,9.609268 65.000000,1.468645
                C67.370560,1.000000 69.741112,1.000000 72.555832,1.467618
                C73.000000,6.845380 73.000000,11.755523 73.000000,16.649864
                C78.616318,16.649864 83.781387,16.649864 89.288696,16.649864
                C89.288696,13.888035 89.288696,11.480635 89.288696,8.924140
                C92.120499,8.924140 94.594780,8.924140 97.037048,9.382486
                C97.005035,12.111292 97.005035,14.381752 97.005035,17.012207
                C99.807472,17.012207 102.213943,17.012207 105.155441,17.012207
                C105.155441,19.895081 105.155441,22.423838 105.155441,24.659389
                C108.106956,24.659389 110.497566,24.659389 113.000000,24.659389
                C113.000000,16.546198 113.000000,8.773099 113.000000,1.000000
                C118.022095,1.000000 123.044189,1.000000 128.533142,1.447555
                C128.973297,4.286445 128.946594,6.677779 128.956573,9.034736
                C128.993225,9.000358 129.062088,8.927133 128.603867,8.960934
                C125.880943,8.994735 123.616234,8.994735 121.075768,8.994735
                C121.075768,19.960773 121.075768,30.514818 120.604164,41.036888
                C115.215050,41.004913 110.297546,41.004913 105.319214,41.004913
                C105.319214,46.583481 105.319214,51.760376 105.319214,56.930847
                C108.117561,56.930847 110.596695,56.930847 113.040619,57.401627
                C113.005394,62.792896 113.005394,67.713387 113.005394,72.650894
                C110.078506,72.650894 107.568512,72.650894 104.711227,72.650894
                C104.711227,69.887871 104.711227,67.482315 104.711227,64.929962
                C101.879913,64.929962 99.405006,64.929962 96.965042,64.964981
                C97.000000,65.000000 97.069908,65.070030 97.037445,64.599007
                C97.004974,59.099361 97.004974,54.070740 97.004974,48.929966
                C93.862709,48.929966 91.396400,48.929966 88.966301,48.965023
                C89.002510,49.000080 89.075943,49.069126 89.075943,49.069126
                C89.075943,41.161652 89.075943,33.254177 89.075943,25.190651
                C86.182449,25.190651 83.784874,25.190651 81.019211,25.190651
                C81.019211,27.778637 81.019211,30.185629 81.019211,32.994228
                C78.387497,32.994228 76.116829,32.994228 73.423195,32.994080
                C73.000221,32.993935 73.073425,33.062866 73.073425,33.062866
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M121.075768,41.068863
                C121.075768,30.514818 121.075768,19.960773 121.075768,8.994735
                C123.616234,8.994735 125.880943,8.994735 128.575073,9.432236
                C129.004501,14.796339 129.004501,19.722940 129.004501,24.815590
                C131.806290,24.815590 134.200195,24.815590 136.683502,24.815590
                C136.683502,19.438883 136.683502,14.251881 136.683502,9.069114
                C133.884644,9.069114 131.402283,9.069114 128.919907,9.069114
                C128.946594,6.677779 128.973297,4.286445 129.000000,1.447555
                C134.022095,1.000000 139.044189,1.000000 144.533142,1.468657
                C145.000000,20.272957 145.000000,38.608597 145.000000,57.000000
                C164.152054,57.000000 182.576035,57.000000 201.000000,57.000000
                C201.000000,59.370556 201.000000,61.741116 200.531357,64.555832
                C192.475723,65.000000 184.888733,65.000000 176.939514,65.000000
                C176.939514,67.857834 176.939514,70.265167 176.939514,72.795273
                C174.163010,72.795273 171.759766,72.795273 168.985809,72.795273
                C168.985809,70.189674 168.985809,67.780540 168.985809,65.362823
                C166.082550,65.362823 163.568130,65.362823 160.683380,65.362823
                C160.683380,68.137688 160.683380,70.544228 160.683380,73.303162
                C157.886246,73.303162 155.479752,73.303162 152.712234,73.303162
                C152.712234,76.083992 152.712234,78.484734 152.712234,81.075912
                C147.198151,81.075912 142.064468,81.075912 136.962891,80.624283
                C136.971405,77.758720 136.947800,75.344795 137.382538,72.962906
                C140.103333,72.994957 142.365799,72.994957 144.666168,72.994957
                C144.666168,70.088058 144.666168,67.577003 144.666168,65.069122
                C141.863007,65.069122 139.393616,65.069122 136.959412,64.598343
                C136.994614,59.099049 136.994614,54.070522 136.994614,48.929970
                C133.862625,48.929970 131.396347,48.929970 128.965057,48.965000
                C129.000031,49.000031 129.070038,49.070038 129.037552,48.619240
                C128.978958,45.758038 128.952835,43.347641 129.384857,40.966305
                C132.109863,40.995369 134.376740,40.995369 136.642639,40.995369
                C136.642639,38.074856 136.642639,35.564548 136.642639,33.327721
                C133.875977,33.327721 131.472229,33.327721 129.068726,33.327721
                C129.068726,36.130077 129.068726,38.604794 128.618073,41.042625
                C125.754936,40.980480 123.342445,40.955223 120.966156,40.964958
                C121.002357,40.999950 121.075768,41.068863 121.075768,41.068863
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M56.930847,129.075806
                C59.416813,129.075806 61.902775,129.075806 64.888504,129.075806
                C64.888504,144.930344 64.888504,160.775238 64.888504,176.987305
                C67.786102,176.987305 70.193451,176.987305 72.968742,176.987305
                C72.968742,179.762390 72.968742,182.172852 72.968742,184.952011
                C75.744423,184.952011 78.155022,184.952011 80.935158,184.952011
                C80.935158,187.727234 80.935158,190.137680 80.935158,192.919617
                C83.711212,192.919617 86.122681,192.919617 89.000000,192.919617
                C89.000000,195.554977 89.000000,197.823090 89.000000,200.545593
                C83.977905,201.000000 78.955818,201.000000 73.466858,200.545593
                C73.000000,197.845886 73.000000,195.600586 73.000000,193.320801
                C70.086998,193.320801 67.582489,193.320801 65.000000,193.320801
                C65.000000,196.094238 65.000000,198.547119 65.000000,201.000000
                C62.629444,201.000000 60.258884,201.000000 57.444164,200.531342
                C57.000000,181.727036 57.000000,163.391403 57.000000,145.000000
                C37.847946,145.000000 19.423973,145.000000 1.000000,145.000000
                C1.000000,142.629440 1.000000,140.258896 1.455451,137.444168
                C4.179990,137.000000 6.449078,137.000000 9.070572,137.000000
                C9.070572,131.470795 9.070572,126.396317 9.070572,121.206619
                C14.515417,121.206619 19.578955,121.206619 24.806034,121.206619
                C24.806034,123.815849 24.806034,126.217445 24.806034,128.993484
                C22.219610,128.993484 19.799347,128.993484 17.200439,128.993484
                C17.200439,131.768784 17.200439,134.170776 17.200439,136.670502
                C22.543575,136.670502 27.735239,136.670502 33.290848,136.670502
                C33.290848,133.929764 33.290848,131.524826 33.290848,129.075821
                C38.798492,129.075821 43.933903,129.075821 49.034737,129.039108
                C49.000168,129.002396 48.930019,128.929947 48.962463,129.387726
                C48.994911,132.106827 48.994911,134.368149 48.994911,136.667053
                C51.912151,136.667053 54.422466,136.667053 57.069981,136.667053
                C57.069981,133.866165 57.069981,131.398056 57.034943,128.966156
                C56.999905,129.002380 56.930847,129.075806 56.930847,129.075806
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M56.531342,1.000000
                C57.000000,19.423975 57.000000,37.847950 57.000000,57.000000
                C38.608601,57.000000 20.272957,57.000000 1.468657,57.000000
                C1.000000,38.406548 1.000000,19.813091 1.000000,1.000000
                C19.353643,1.000000 37.708164,1.000000 56.531342,1.000000
            M12.651775,9.000018
                C11.046052,9.184923 8.920198,8.129902 8.951912,11.360235
                C9.074053,23.801643 9.001446,36.244965 9.001446,48.759769
                C22.547382,48.759769 35.618149,48.759769 48.757187,48.759769
                C48.757187,35.447411 48.757187,22.376585 48.757187,9.000000
                C36.885498,9.000000 25.254080,9.000000 12.651775,9.000018
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M201.000000,56.531342
                C182.576035,57.000000 164.152054,57.000000 145.000000,57.000000
                C145.000000,38.608597 145.000000,20.272957 145.000000,1.468657
                C163.593460,1.000000 182.186905,1.000000 201.000000,1.000000
                C201.000000,19.353643 201.000000,37.708164 201.000000,56.531342
            M153.000000,23.504719
                C153.000000,31.934708 153.000000,40.364697 153.000000,48.711788
                C166.647949,48.711788 179.718079,48.711788 192.711533,48.711788
                C192.711533,35.351490 192.711533,22.281399 192.711533,9.288725
                C179.350967,9.288725 166.280869,9.288725 153.000000,9.288725
                C153.000000,13.886424 153.000000,18.197165 153.000000,23.504719
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M1.000000,145.468658
                C19.423973,145.000000 37.847946,145.000000 57.000000,145.000000
                C57.000000,163.391403 57.000000,181.727036 57.000000,200.531342
                C38.406548,201.000000 19.813091,201.000000 1.000000,201.000000
                C1.000000,182.646362 1.000000,164.291840 1.000000,145.468658
            M9.000000,185.439484
                C9.000000,187.876755 9.000000,190.314026 9.000000,192.731552
                C22.606279,192.731552 35.676720,192.731552 48.730118,192.731552
                C48.730118,179.390793 48.730118,166.320343 48.730118,153.271332
                C35.387905,153.271332 22.317398,153.271332 9.000000,153.271332
                C9.000000,163.845840 9.000000,174.150894 9.000000,185.439484
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M136.930786,81.075912
                C142.064468,81.075912 147.198151,81.075912 152.712234,81.075912
                C152.712234,78.484734 152.712234,76.083992 152.712234,73.303162
                C155.479752,73.303162 157.886246,73.303162 160.683380,73.303162
                C160.683380,70.544228 160.683380,68.137688 160.683380,65.362823
                C163.568130,65.362823 166.082550,65.362823 168.985809,65.362823
                C168.985809,67.780540 168.985809,70.189674 168.985809,72.795273
                C171.759766,72.795273 174.163010,72.795273 176.939514,72.795273
                C176.939514,70.265167 176.939514,67.857834 176.939514,65.000000
                C184.888733,65.000000 192.475723,65.000000 200.531357,65.000000
                C201.000000,67.370560 201.000000,69.741112 200.546082,72.555832
                C197.853073,73.000000 195.613968,73.000000 193.072723,73.000000
                C193.072723,75.932915 193.072723,78.497505 192.601440,81.033295
                C187.203568,81.004486 182.276993,81.004486 177.184418,81.004486
                C177.184418,83.806335 177.184418,86.200233 177.184418,88.683487
                C182.561142,88.683487 187.748154,88.683487 192.930756,88.683487
                C192.930756,85.884644 192.930756,83.402283 193.378067,80.957062
                C196.216919,80.996132 198.608459,80.998062 201.000000,81.000000
                C201.000000,88.687576 201.000000,96.375153 200.552490,104.531364
                C197.713333,104.976639 195.321671,104.953278 192.964996,104.964951
                C192.999985,104.999977 193.069992,105.070007 193.037537,104.611191
                C193.005066,101.880165 193.005066,99.607964 193.005066,96.968857
                C184.845490,96.968857 177.109039,96.968857 169.001968,96.968857
                C169.001968,91.533241 169.001968,86.456429 169.001968,81.198257
                C166.220215,81.198257 163.820374,81.198257 160.870605,81.198257
                C160.870605,86.541283 160.870605,91.749924 160.870605,97.300789
                C157.903381,97.300789 155.489212,97.300789 152.713257,97.300789
                C152.713257,100.079094 152.713257,102.484795 152.713257,104.695374
                C147.245178,104.695374 142.165970,104.695374 136.924194,104.695374
                C136.924194,101.904358 136.924194,99.417625 137.382538,96.962929
                C140.102905,96.994957 142.364914,96.994957 144.667603,96.994957
                C144.667603,94.092552 144.667603,91.580109 144.667603,89.075859
                C141.867096,89.075859 139.398941,89.075859 136.962891,88.624268
                C137.020020,85.758453 137.045029,83.344231 137.034988,80.966248
                C136.999924,81.002480 136.930786,81.075912 136.930786,81.075912
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M193.068954,145.075699
                C187.945267,145.075699 182.821579,145.075699 177.165649,145.075699
                C177.165649,139.753540 177.165649,134.569656 177.165649,128.994995
                C174.374847,128.994995 172.108871,128.994995 169.383530,128.962952
                C168.924149,128.930893 168.997574,128.999939 169.001343,128.577637
                C169.005096,125.783478 169.005096,123.411598 169.005096,120.930000
                C165.839218,120.930000 163.384598,120.930000 160.929993,120.930000
                C160.929993,120.930000 160.999969,120.999985 161.002472,120.563934
                C161.004990,115.196205 161.004990,110.264526 161.004990,105.197227
                C163.827057,105.197227 166.226379,105.197227 168.993744,105.197227
                C168.993744,107.789986 168.993744,110.194603 168.993744,112.671082
                C174.557327,112.671082 179.744217,112.671082 185.276489,112.671082
                C185.276489,109.924576 185.276489,107.511185 185.276489,105.070007
                C188.110458,105.070007 190.590225,105.070007 193.069992,105.070007
                C193.069992,105.070007 192.999985,104.999977 192.997437,105.422058
                C192.994904,108.211929 192.994904,110.579720 192.994904,113.000000
                C196.115097,113.000000 198.557541,113.000000 201.000000,113.000000
                C201.000000,118.022095 201.000000,123.044189 200.552765,128.533142
                C197.716125,129.024399 195.326721,129.048798 192.966339,128.615082
                C192.995377,125.890099 192.995377,123.623215 192.995377,121.357384
                C190.074844,121.357384 187.564545,121.357384 185.327744,121.357384
                C185.327744,124.124069 185.327744,126.527809 185.327744,128.931213
                C188.130127,128.931213 190.604843,128.931213 193.042618,129.401337
                C193.026764,134.939545 193.047867,140.007629 193.068954,145.075699
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M49.069305,129.075821
                C43.933903,129.075821 38.798492,129.075821 33.290848,129.075821
                C33.290848,131.524826 33.290848,133.929764 33.290848,136.670502
                C27.735239,136.670502 22.543575,136.670502 17.200439,136.670502
                C17.200439,134.170776 17.200439,131.768784 17.200439,128.993484
                C19.799347,128.993484 22.219610,128.993484 24.806034,128.993484
                C24.806034,126.217445 24.806034,123.815849 24.806034,121.206619
                C19.578955,121.206619 14.515417,121.206619 9.070572,121.206619
                C9.070572,126.396317 9.070572,131.470795 9.070572,137.000000
                C6.449078,137.000000 4.179990,137.000000 1.455451,137.000000
                C1.000000,126.645775 1.000000,116.291542 1.447538,105.468658
                C4.286407,104.974678 6.677739,104.949364 9.037039,105.383453
                C9.005009,108.111946 9.005009,110.381042 9.005009,113.164879
                C17.251736,113.164879 25.105234,113.164879 33.305573,113.164879
                C33.305573,116.094116 33.305573,118.496246 33.305573,121.069885
                C38.809986,121.069885 43.940044,121.069885 49.070099,121.069885
                C49.070099,121.069885 48.999989,120.999985 48.997467,121.416267
                C49.019730,124.246971 49.044518,126.661400 49.069305,129.075821
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M152.924301,193.068939
                C152.924301,190.588470 152.924301,188.107986 152.924301,185.261063
                C155.513382,185.261063 157.924454,185.261063 160.704803,185.261063
                C160.704803,182.501450 160.704803,180.096313 160.704803,177.162659
                C171.563110,177.162659 182.076920,177.162659 193.005753,177.162659
                C193.005753,174.387207 193.005753,172.117645 193.005997,169.424042
                C193.006241,169.000000 192.937302,169.073196 192.937302,169.073196
                C195.326721,169.048798 197.716125,169.024399 200.552765,169.000000
                C201.000000,179.666748 201.000000,190.333496 201.000000,201.000000
                C198.598312,201.000000 196.293884,201.000000 193.494736,200.544556
                C193.000000,197.841827 193.000000,195.594543 193.000000,192.924194
                C187.374908,192.924194 182.152771,192.924194 176.965195,192.960907
                C176.999771,192.997620 177.069977,193.070068 177.037537,192.612289
                C177.005081,189.893188 177.005081,187.631866 177.005081,185.332947
                C174.090378,185.332947 171.578217,185.332947 168.930023,185.332947
                C168.930023,188.133850 168.930023,190.601959 168.965088,193.033813
                C169.000153,192.997559 169.069336,192.924133 168.599060,192.959351
                C163.060608,193.019379 157.992462,193.044159 152.924301,193.068939
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M97.069061,8.924140
                C94.594780,8.924140 92.120499,8.924140 89.288696,8.924140
                C89.288696,11.480635 89.288696,13.888035 89.288696,16.649864
                C83.781387,16.649864 78.616318,16.649864 73.000000,16.649864
                C73.000000,11.755523 73.000000,6.845380 73.000000,1.467618
                C80.687576,1.000000 88.375153,1.000000 96.531364,1.447511
                C96.976639,4.286673 96.953278,6.678324 96.964966,9.033768
                C97.000015,8.997561 97.069061,8.924140 97.069061,8.924140
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M112.555832,1.000000
                C113.000000,8.773099 113.000000,16.546198 113.000000,24.659389
                C110.497566,24.659389 108.106956,24.659389 105.155441,24.659389
                C105.155441,22.423838 105.155441,19.895081 105.155441,17.012207
                C102.213943,17.012207 99.807472,17.012207 97.005035,17.012207
                C97.005035,14.381752 97.005035,12.111292 97.037048,9.382486
                C97.069061,8.924140 97.000015,8.997561 97.422073,9.001330
                C100.211929,9.005099 102.579727,9.005099 105.000000,9.005099
                C105.000000,5.884750 105.000000,3.442375 105.000000,1.000000
                C107.370560,1.000000 109.741112,1.000000 112.555832,1.000000
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M1.000000,81.466858
                C6.043030,81.001801 11.086061,81.003601 16.564606,81.003937
                C17.000120,81.002480 16.929964,80.930092 16.962437,81.387848
                C16.994907,84.107285 16.994907,86.368965 16.994907,89.146194
                C14.106922,89.146194 11.577095,89.146194 9.069098,89.146194
                C9.069098,92.137764 9.069098,94.606857 8.621666,97.040718
                C5.782822,97.003662 3.391411,97.001831 1.000000,97.000000
                C1.000000,91.977905 1.000000,86.955818 1.000000,81.466858
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M193.034485,145.039001
                C193.047867,140.007629 193.026764,134.939545 193.005951,129.435730
                C193.006241,129.000000 192.937302,129.073196 192.937302,129.073196
                C195.326721,129.048798 197.716125,129.024399 200.552765,129.000000
                C201.000000,134.022095 201.000000,139.044189 200.552490,144.533142
                C197.713333,144.976639 195.321671,144.953278 192.930023,144.929916
                C192.930023,144.929916 193.000031,145.002289 193.034485,145.039001
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M176.930618,192.924194
                C182.152771,192.924194 187.374908,192.924194 193.000000,192.924194
                C193.000000,195.594543 193.000000,197.841827 193.000000,200.544556
                C187.977905,201.000000 182.955811,201.000000 177.466858,200.552322
                C176.976868,197.711166 176.953751,195.317673 176.930618,192.924194
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M152.960999,193.034485
                C157.992462,193.044159 163.060608,193.019379 168.566895,193.407608
                C169.003357,196.213760 169.001678,198.606873 169.000000,201.000000
                C163.977905,201.000000 158.955811,201.000000 153.466858,200.552490
                C153.023361,197.713333 153.046722,195.321671 153.070084,192.930023
                C153.070084,192.930023 152.997711,193.000031 152.960999,193.034485
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M192.962463,145.386978
                C195.321671,144.953278 197.713333,144.976639 200.552490,145.000000
                C201.000000,147.370560 201.000000,149.741104 201.000000,152.555832
                C198.557587,153.000000 196.115173,153.000000 192.994904,153.000000
                C192.994904,150.579773 192.994904,148.211914 192.962463,145.386978
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M104.555832,1.000000
                C105.000000,3.442375 105.000000,5.884750 105.000000,9.005099
                C102.579727,9.005099 100.211929,9.005099 97.387024,9.037537
                C96.953278,6.678324 96.976639,4.286673 97.000000,1.447511
                C99.370560,1.000000 101.741112,1.000000 104.555832,1.000000
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M65.444168,201.000000
                C65.000000,198.547119 65.000000,196.094238 65.000000,193.320801
                C67.582489,193.320801 70.086998,193.320801 73.000000,193.320801
                C73.000000,195.600586 73.000000,197.845886 73.000000,200.545593
                C70.629440,201.000000 68.258888,201.000000 65.444168,201.000000
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M129.444168,201.000000
                C129.000000,198.547119 129.000000,196.094238 129.000000,193.320801
                C131.581680,193.320801 134.084595,193.320801 137.000000,193.320801
                C137.000000,195.600586 137.000000,197.845886 137.000000,200.545593
                C134.629440,201.000000 132.258896,201.000000 129.444168,201.000000
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M152.613022,192.962463
                C153.046722,195.321671 153.023361,197.713333 153.000000,200.552490
                C150.629440,201.000000 148.258896,201.000000 145.444168,201.000000
                C145.000000,198.557587 145.000000,196.115173 145.000000,192.994904
                C147.420227,192.994904 149.788086,192.994904 152.613022,192.962463
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M169.444168,201.000000
                C169.001678,198.606873 169.003357,196.213760 169.037186,193.372375
                C169.069336,192.924133 169.000153,192.997559 169.416168,193.001297
                C172.244781,193.026718 174.657379,193.048386 177.069977,193.070068
                C177.069977,193.070068 176.999771,192.997620 176.965195,192.960907
                C176.953751,195.317673 176.976868,197.711166 177.000000,200.552322
                C174.629440,201.000000 172.258896,201.000000 169.444168,201.000000
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M1.000000,97.444168
                C3.391411,97.001831 5.782822,97.003662 8.587152,97.003990
                C9.000070,97.002487 8.929900,96.930122 8.962421,97.381142
                C8.973261,100.244736 8.951579,102.657303 8.964962,105.033676
                C9.000026,104.997482 9.069070,104.924049 9.069070,104.924049
                C6.677739,104.949364 4.286407,104.974678 1.447538,105.000000
                C1.000000,102.629440 1.000000,100.258888 1.000000,97.444168
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M201.000000,112.555832
                C198.557541,113.000000 196.115097,113.000000 192.994904,113.000000
                C192.994904,110.579720 192.994904,108.211929 192.962463,105.387024
                C195.321671,104.953278 197.713333,104.976639 200.552490,105.000000
                C201.000000,107.370560 201.000000,109.741112 201.000000,112.555832
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M193.072723,81.062096
                C193.072723,78.497505 193.072723,75.932915 193.072723,73.000000
                C195.613968,73.000000 197.853073,73.000000 200.546082,73.000000
                C201.000000,75.370560 201.000000,77.741112 201.000000,80.555832
                C198.608459,80.998062 196.216919,80.996132 193.412445,80.993721
                C192.999512,80.993240 193.072723,81.062096 193.072723,81.062096
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M1.000000,65.444168
                C3.452887,65.000000 5.905774,65.000000 8.679218,65.000000
                C8.679218,67.582481 8.679218,70.086998 8.679218,73.000000
                C6.399427,73.000000 4.154115,73.000000 1.454401,73.000000
                C1.000000,70.629440 1.000000,68.258888 1.000000,65.444168
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M97.079498,144.931290
                C97.055870,147.287430 97.032234,149.643555 97.094887,152.401062
                C97.181175,152.802414 97.254227,152.719910 97.254227,152.719910
                C89.314697,152.719910 81.375160,152.719910 73.218300,152.719910
                C73.218300,147.574142 73.218300,142.502350 73.218300,137.045837
                C75.746513,137.045837 78.168900,137.045837 80.783356,137.045837
                C80.783356,134.258789 80.783356,131.849869 80.783356,129.054626
                C78.264465,129.054626 75.849594,129.054626 73.220688,129.054626
                C73.220688,126.268639 73.220688,123.859512 73.220688,121.063042
                C75.726799,121.063042 78.141441,121.063042 80.774933,121.063042
                C80.774933,118.278809 80.774933,115.871468 80.774933,112.994629
                C70.423897,112.994629 60.149166,112.994629 49.437149,112.996094
                C48.999870,112.997566 49.070061,113.069977 49.037560,112.618935
                C49.026726,109.755272 49.048393,107.342644 49.035030,104.965012
                C49.000000,105.000000 48.929939,105.069977 49.387711,105.037537
                C52.106812,105.005089 54.368134,105.005089 56.667068,105.005089
                C56.667068,102.087624 56.667068,99.577194 56.667068,96.930023
                C53.866165,96.930023 51.398052,96.930023 48.964966,96.965004
                C48.999989,96.999985 49.070099,97.069885 49.037582,96.619102
                C48.978893,93.757927 48.952721,91.347527 49.384697,88.966248
                C52.109745,88.995369 54.376640,88.995369 56.642700,88.995369
                C56.642700,86.074928 56.642700,83.564598 56.642700,81.327675
                C53.876095,81.327675 51.472340,81.327675 49.068550,81.327675
                C49.068550,84.129982 49.068550,86.604683 48.611183,89.042580
                C45.892620,89.005768 43.631424,89.005768 40.855679,89.005768
                C40.855679,86.108513 40.855679,83.578468 40.855679,80.929962
                C37.866169,80.929962 35.398129,80.929962 32.966286,80.964981
                C33.002476,80.999992 33.075912,81.068924 33.040703,80.610367
                C33.005489,77.881950 33.005489,75.612091 33.005489,73.351822
                C43.923756,73.351822 54.422249,73.351822 65.289078,73.351822
                C65.289078,78.766647 65.289078,83.829941 65.289078,89.075836
                C70.799568,89.075836 75.934402,89.075836 81.034714,89.039124
                C81.000175,89.002411 80.930092,88.929962 80.962555,89.401001
                C80.995026,94.905281 80.995026,99.938515 80.995026,104.930946
                C86.846825,104.930946 91.961266,104.930946 97.040588,105.389503
                C97.005470,108.116158 97.005470,110.384254 97.005470,113.188095
                C102.590149,113.188095 107.784454,113.188095 113.308594,113.188095
                C113.308594,118.791496 113.308594,123.851540 113.308594,129.069946
                C118.809074,129.069946 123.939514,129.069946 129.033752,129.034943
                C128.997543,128.999954 128.924103,128.931015 128.924103,128.931015
                C128.924103,139.486252 128.924103,150.041473 128.924103,160.994247
                C126.379326,160.994247 124.113731,160.994247 121.424103,160.994003
                C121.000076,160.993759 121.073280,161.062698 121.073280,161.062698
                C121.073280,155.943604 121.073280,150.824493 121.073280,145.005173
                C113.251343,145.005173 105.565781,145.005173 97.437805,144.581085
                C96.995377,141.882126 96.995377,139.607239 96.995377,136.965637
                C99.826294,136.965637 102.234352,136.965637 104.806412,136.965637
                C104.806412,131.522690 104.806412,126.455620 104.806412,121.358047
                C102.084122,121.358047 99.569641,121.358047 96.684921,121.358047
                C96.684921,124.129791 96.684921,126.538086 96.684921,129.308090
                C93.897919,129.308090 91.495171,129.308090 89.309631,129.308090
                C89.309631,134.773102 89.309631,139.848846 89.309631,144.931290
                C92.105957,144.931290 94.592728,144.931290 97.079498,144.931290
            M70.406319,97.000290
                C68.667549,97.000290 66.928780,97.000290 65.247009,97.000290
                C65.247009,99.965630 65.247009,102.350723 65.247009,104.791138
                C67.883743,104.791138 70.268265,104.791138 73.808113,104.791138
                C72.884415,101.879799 72.110909,99.441856 70.406319,97.000290
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M193.037537,104.611191
                C190.590225,105.070007 188.110458,105.070007 185.276489,105.070007
                C185.276489,107.511185 185.276489,109.924576 185.276489,112.671082
                C179.744217,112.671082 174.557327,112.671082 168.993744,112.671082
                C168.993744,110.194603 168.993744,107.789986 168.993744,105.197227
                C166.226379,105.197227 163.827057,105.197227 161.004990,105.197227
                C161.004990,110.264526 161.004990,115.196205 161.037445,120.598961
                C158.594681,121.070038 156.119446,121.070038 153.287384,121.070038
                C153.287384,123.484047 153.287384,125.890732 153.287384,128.995102
                C145.256485,128.995102 137.562927,128.995102 129.396729,128.963058
                C128.924103,128.931015 128.997543,128.999954 129.001266,128.563873
                C129.004990,123.214645 129.004990,118.301491 129.004990,112.871330
                C126.111122,112.871330 123.590309,112.871330 120.924141,112.871330
                C120.924141,109.873810 120.924141,107.402290 121.381989,104.962860
                C124.213257,104.994949 126.586678,104.994949 128.930878,104.994949
                C128.930878,101.836845 128.930878,99.380501 129.381683,96.959351
                C132.244995,97.019699 134.657516,97.044868 137.033829,97.034996
                C136.997620,96.999954 136.924194,96.930901 136.924194,96.930901
                C136.924194,99.417625 136.924194,101.904358 136.924194,104.695374
                C142.165970,104.695374 147.245178,104.695374 152.713257,104.695374
                C152.713257,102.484795 152.713257,100.079094 152.713257,97.300789
                C155.489212,97.300789 157.903381,97.300789 160.870605,97.300789
                C160.870605,91.749924 160.870605,86.541283 160.870605,81.198257
                C163.820374,81.198257 166.220215,81.198257 169.001968,81.198257
                C169.001968,86.456429 169.001968,91.533241 169.001968,96.968857
                C177.109039,96.968857 184.845490,96.968857 193.005066,96.968857
                C193.005066,99.607964 193.005066,101.880165 193.037537,104.611191
            M137.000320,118.410149
                C138.161270,123.924843 142.188828,119.503006 144.669846,121.191368
                C144.669846,118.097916 144.669846,115.598869 144.669846,113.290627
                C141.944550,113.290627 139.562958,113.290627 137.000000,113.290627
                C137.000000,114.875259 137.000000,116.170242 137.000320,118.410149
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M49.037579,120.618698
                C43.940044,121.069885 38.809986,121.069885 33.305573,121.069885
                C33.305573,118.496246 33.305573,116.094116 33.305573,113.164879
                C25.105234,113.164879 17.251736,113.164879 9.005009,113.164879
                C9.005009,110.381042 9.005009,108.111946 9.037039,105.383453
                C9.069070,104.924049 9.000026,104.997482 9.437088,105.001221
                C17.564495,105.004951 25.254841,105.004951 33.070038,105.004951
                C33.070038,101.878891 33.070038,99.404495 33.035027,96.965042
                C33.000015,96.999992 32.930054,97.069946 33.400566,97.037460
                C38.937420,97.026611 44.003761,97.048248 49.070099,97.069885
                C49.070099,97.069885 48.999989,96.999985 48.997467,97.416077
                C48.973274,100.244774 48.951607,102.657372 48.929939,105.069977
                C48.929939,105.069977 49.000000,105.000000 48.577209,104.997452
                C45.893116,104.994911 43.631817,104.994911 41.332947,104.994911
                C41.332947,107.912125 41.332947,110.422585 41.332947,113.069977
                C44.133858,113.069977 46.601959,113.069977 49.070061,113.069977
                C49.070061,113.069977 48.999870,112.997566 48.965317,112.960846
                C48.955524,115.338577 48.980293,117.753044 49.037579,120.618698
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M161.000000,149.000000
                C161.000000,153.137680 161.000000,156.781464 161.000000,160.711700
                C153.053741,160.711700 145.315613,160.711700 137.287262,160.711700
                C137.287262,153.051559 137.287262,145.313446 137.287262,137.286194
                C144.950638,137.286194 152.688721,137.286194 161.000000,137.286194
                C161.000000,140.967468 161.000000,144.736801 161.000000,149.000000
            M152.942245,145.720123
                C150.347382,145.433807 147.752533,145.147491 145.295029,144.876343
                C145.295029,148.059555 145.295029,150.445312 145.295029,152.744553
                C147.982788,152.744553 150.369110,152.744553 152.996094,152.744553
                C152.996094,150.548920 152.996094,148.606018 152.942245,145.720123
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M97.280632,169.255722
                C97.193459,164.074295 97.106285,158.892868 97.136665,153.215668
                C97.254227,152.719910 97.181175,152.802414 97.150459,152.837219
                C99.582169,152.872009 102.044594,152.872009 104.752151,152.872009
                C104.752151,158.302521 104.752151,163.377197 104.752151,169.008682
                C102.527740,169.008682 100.272614,169.008682 97.607910,169.095505
                C97.198334,169.182327 97.280632,169.255722 97.280632,169.255722
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M73.002106,163.128159
                C75.441864,161.889114 77.879807,161.115601 80.791138,160.191910
                C80.791138,163.731323 80.791138,166.116470 80.791138,168.752991
                C78.350533,168.752991 75.964180,168.752991 73.000290,168.752991
                C73.000290,167.071228 73.000290,165.332458 73.002106,163.128159
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M120.965683,160.957092
                C120.931282,163.395157 120.931282,165.869873 120.931282,168.672256
                C118.527786,168.672256 116.124046,168.672256 113.357376,168.672256
                C113.357376,166.436783 113.357376,163.928833 113.357376,161.004623
                C115.623253,161.004623 117.890144,161.004623 120.615158,161.033661
                C121.073280,161.062698 121.000076,160.993759 120.965683,160.957092
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M97.062767,176.926712
                C94.583725,176.926712 92.104675,176.926712 89.312927,176.926712
                C89.312927,174.492783 89.312927,172.087173 89.312927,169.019730
                C91.498535,169.019730 93.907570,169.019730 96.798622,169.137726
                C97.280632,169.255722 97.198334,169.182327 97.163589,169.151611
                C97.083969,171.471527 97.039093,173.822159 96.994034,176.586349
                C96.993843,176.999924 97.062767,176.926712 97.062767,176.926712
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M96.957169,177.034332
                C99.395248,177.068726 101.869995,177.068726 104.672287,177.068726
                C104.672287,179.472244 104.672287,181.875992 104.672287,184.642639
                C102.435448,184.642639 99.925140,184.642639 97.004631,184.642639
                C97.004631,182.376724 97.004631,180.109848 97.033699,177.384827
                C97.062767,176.926712 96.993843,176.999924 96.957169,177.034332
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M49.034737,129.039108
                C49.044518,126.661400 49.019730,124.246971 48.962440,121.381287
                C51.385357,120.930016 53.840778,120.930016 56.994953,120.930016
                C56.994953,123.413559 56.994953,125.786835 56.962898,128.617950
                C56.930847,129.075806 56.999905,129.002380 56.583870,128.998657
                C53.755230,128.973282 51.342625,128.951614 48.930019,128.929947
                C48.930019,128.929947 49.000168,129.002396 49.034737,129.039108
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M160.962448,121.387283
                C163.384598,120.930000 165.839218,120.930000 169.005096,120.930000
                C169.005096,123.411598 169.005096,125.783478 169.037552,128.612671
                C166.615387,129.070007 164.160751,129.070007 160.994904,129.070007
                C160.994904,126.588356 160.994904,124.216461 160.962448,121.387283
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M193.042908,168.965607
                C190.604858,168.931213 188.130142,168.931213 185.327759,168.931213
                C185.327759,166.527802 185.327759,164.124069 185.327759,161.357391
                C187.564529,161.357391 190.074829,161.357391 192.995377,161.357391
                C192.995377,163.623199 192.995377,165.890091 192.966339,168.615082
                C192.937302,169.073196 193.006241,169.000000 193.042908,168.965607
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M81.069244,89.075836
                C75.934402,89.075836 70.799568,89.075836 65.289078,89.075836
                C65.289078,83.829941 65.289078,78.766647 65.289078,73.351822
                C54.422249,73.351822 43.923756,73.351822 33.005489,73.351822
                C33.005489,75.612091 33.005489,77.881950 32.569603,80.578369
                C27.065800,80.979980 21.997881,80.955040 16.929964,80.930099
                C16.929964,80.930092 17.000120,81.002480 17.034637,81.039207
                C17.069153,78.591743 17.069153,76.107552 17.069153,73.203835
                C19.512424,73.096344 21.930326,72.989967 24.719526,72.867256
                C24.719526,70.480934 24.719526,68.068115 24.719526,65.139221
                C43.578465,65.139221 62.082561,65.139221 80.963409,65.139221
                C80.963409,59.567730 80.963409,54.489151 80.963409,49.005013
                C83.611275,49.005013 85.884232,49.005013 88.616562,49.037071
                C89.075943,49.069126 89.002510,49.000080 88.998764,49.436096
                C88.995026,54.900703 88.995026,59.929298 88.995026,65.070030
                C92.137314,65.070030 94.603607,65.070030 97.069908,65.070030
                C97.069908,65.070030 97.000000,65.000000 96.997513,65.436050
                C96.995026,70.806168 96.995026,75.740227 96.995026,80.797874
                C94.165009,80.797874 91.764389,80.797874 88.994400,80.797874
                C88.994400,78.198860 88.994400,75.793373 88.994400,73.341766
                C83.429802,73.341766 78.243874,73.341766 73.332825,73.341766
                C73.332825,76.104805 73.332825,78.510719 73.332825,81.265594
                C76.080177,81.265594 78.491219,81.265594 81.069244,81.265594
                C81.069244,84.113297 81.069244,86.594566 81.069244,89.075836
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M72.965820,32.957268
                C72.931427,35.395309 72.931427,37.870018 72.931427,40.672321
                C70.527672,40.672321 68.123917,40.672321 65.357300,40.672321
                C65.357300,38.435406 65.357300,35.925072 65.357300,33.004639
                C67.623344,33.004639 69.890244,33.004639 72.615280,33.033752
                C73.073425,33.062866 73.000221,32.993935 72.965820,32.957268
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M65.002106,51.128136
                C67.441864,49.889091 69.879814,49.115589 72.791145,48.191891
                C72.791145,51.731331 72.791145,54.116486 72.791145,56.752991
                C70.350525,56.752991 67.964172,56.752991 65.000290,56.752991
                C65.000290,55.071217 65.000290,53.332443 65.002106,51.128136
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M81.034714,89.039124
                C81.069244,86.594566 81.069244,84.113297 81.069244,81.265594
                C78.491219,81.265594 76.080177,81.265594 73.332825,81.265594
                C73.332825,78.510719 73.332825,76.104805 73.332825,73.341766
                C78.243874,73.341766 83.429802,73.341766 88.994400,73.341766
                C88.994400,75.793373 88.994400,78.198860 88.994400,80.797874
                C91.764389,80.797874 94.165009,80.797874 96.995026,80.797874
                C96.995026,75.740227 96.995026,70.806168 96.962555,65.401031
                C99.405006,64.929962 101.879913,64.929962 104.711227,64.929962
                C104.711227,67.482315 104.711227,69.887871 104.711227,72.650894
                C107.568512,72.650894 110.078506,72.650894 113.005394,72.650894
                C113.005394,67.713387 113.005394,62.792896 113.003906,57.436153
                C113.002411,56.999901 112.930000,57.070004 113.387283,57.037552
                C116.216461,57.005096 118.588364,57.005096 121.070007,57.005096
                C121.070007,53.839291 121.070007,51.384644 121.034996,48.965004
                C120.999985,49.000015 120.929962,49.070038 121.381004,49.037548
                C124.244713,49.026718 126.657372,49.048378 129.070038,49.070038
                C129.070038,49.070038 129.000031,49.000031 128.997528,49.435570
                C129.019669,54.939320 129.044312,60.007526 128.610413,65.040604
                C125.886398,65.005470 123.620949,65.005470 120.838837,65.005470
                C120.838837,70.579826 120.838837,75.771454 120.838837,81.285683
                C117.902138,81.285683 115.494400,81.285683 113.075821,81.285683
                C113.075821,84.117249 113.075821,86.593117 112.604240,89.036949
                C107.102295,89.004913 102.071922,89.004913 97.069099,89.004913
                C97.069099,92.141022 97.069099,94.608467 96.611588,97.040718
                C93.892838,97.005516 91.631592,97.005516 88.855766,97.005516
                C88.855766,94.102402 88.855766,91.580887 88.855766,88.929962
                C85.866203,88.929962 83.398148,88.929962 80.930092,88.929962
                C80.930092,88.929962 81.000175,89.002411 81.034714,89.039124
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M113.039124,56.965374
                C110.596695,56.930847 108.117561,56.930847 105.319214,56.930847
                C105.319214,51.760376 105.319214,46.583481 105.319214,41.004913
                C110.297546,41.004913 115.215050,41.004913 120.604164,41.036888
                C121.075768,41.068863 121.002357,40.999950 120.998642,41.416039
                C120.973274,44.244762 120.951614,46.657398 120.929962,49.070038
                C120.929962,49.070038 120.999985,49.000015 120.577667,48.997459
                C117.783478,48.994904 115.411598,48.994904 112.930000,48.994904
                C112.930000,52.160736 112.930000,54.615372 112.930000,57.070004
                C112.930000,57.070004 113.002411,56.999901 113.039124,56.965374
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M97.037445,64.599007
                C94.603607,65.070030 92.137314,65.070030 88.995026,65.070030
                C88.995026,59.929298 88.995026,54.900703 88.962555,49.401039
                C91.396400,48.929966 93.862709,48.929966 97.004974,48.929966
                C97.004974,54.070740 97.004974,59.099361 97.037445,64.599007
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M113.075821,89.068985
                C113.075821,86.593117 113.075821,84.117249 113.075821,81.285683
                C115.494400,81.285683 117.902138,81.285683 120.838837,81.285683
                C120.838837,75.771454 120.838837,70.579826 120.838837,65.005470
                C123.620949,65.005470 125.886398,65.005470 128.575943,65.003891
                C129.000031,65.002319 128.930023,64.929939 128.962463,65.387268
                C128.994904,68.216492 128.994904,70.588379 128.994904,73.069984
                C132.160797,73.069984 134.615433,73.069984 137.033844,73.034950
                C136.997620,72.999916 136.924194,72.930862 136.924194,72.930862
                C136.947800,75.344795 136.971405,77.758720 136.962891,80.624283
                C136.930786,81.075912 136.999924,81.002480 136.577621,80.998688
                C133.783432,80.994904 131.411545,80.994904 128.924194,80.994904
                C128.924194,84.160507 128.924194,86.614944 128.960907,89.034805
                C128.997604,89.000237 129.070099,88.930115 128.599518,88.962570
                C123.062622,88.973373 117.996300,88.951729 112.966187,88.965073
                C113.002403,89.000061 113.075821,89.068985 113.075821,89.068985
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M129.034485,65.039032
                C129.044312,60.007526 129.019669,54.939320 128.962555,49.400539
                C131.396347,48.929970 133.862625,48.929970 136.994614,48.929970
                C136.994614,54.070522 136.994614,59.099049 136.996124,64.563820
                C136.997635,65.000069 137.070038,64.929962 136.618988,64.962456
                C133.755295,64.973282 131.342667,64.951607 128.930023,64.929939
                C128.930023,64.929939 129.000031,65.002319 129.034485,65.039032
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M128.956573,9.034736
                C131.402283,9.069114 133.884644,9.069114 136.683502,9.069114
                C136.683502,14.251881 136.683502,19.438883 136.683502,24.815590
                C134.200195,24.815590 131.806290,24.815590 129.004501,24.815590
                C129.004501,19.722940 129.004501,14.796339 129.033295,9.398436
                C129.062088,8.927133 128.993225,9.000358 128.956573,9.034736
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M121.380997,49.037548
                C120.951614,46.657398 120.973274,44.244762 120.962448,41.381042
                C123.342445,40.955223 125.754936,40.980480 128.583679,41.005959
                C128.999924,41.006180 128.926727,40.937241 128.926727,40.937241
                C128.952835,43.347641 128.978958,45.758038 129.037552,48.619240
                C126.657372,49.048378 124.244713,49.026718 121.380997,49.037548
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M129.034332,41.042847
                C129.068726,38.604794 129.068726,36.130077 129.068726,33.327721
                C131.472229,33.327721 133.875977,33.327721 136.642639,33.327721
                C136.642639,35.564548 136.642639,38.074856 136.642639,40.995369
                C134.376740,40.995369 132.109863,40.995369 129.384857,40.966305
                C128.926727,40.937241 128.999924,41.006180 129.034332,41.042847
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M136.960938,65.034592
                C139.393616,65.069122 141.863007,65.069122 144.666168,65.069122
                C144.666168,67.577003 144.666168,70.088058 144.666168,72.994957
                C142.365799,72.994957 140.103333,72.994957 137.382538,72.962906
                C136.924194,72.930862 136.997620,72.999916 137.001343,72.583878
                C137.026703,69.755211 137.048370,67.342583 137.070038,64.929962
                C137.070038,64.929962 136.997635,65.000069 136.960938,65.034592
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M48.962463,129.387726
                C51.342625,128.951614 53.755230,128.973282 56.618908,128.962448
                C57.069981,131.398056 57.069981,133.866165 57.069981,136.667053
                C54.422466,136.667053 51.912151,136.667053 48.994911,136.667053
                C48.994911,134.368149 48.994911,132.106827 48.962463,129.387726
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M13.137218,9.000010
                C25.254080,9.000000 36.885498,9.000000 48.757187,9.000000
                C48.757187,22.376585 48.757187,35.447411 48.757187,48.759769
                C35.618149,48.759769 22.547382,48.759769 9.001446,48.759769
                C9.001446,36.244965 9.074053,23.801643 8.951912,11.360235
                C8.920198,8.129902 11.046052,9.184923 13.137218,9.000010
            M30.484844,17.000000
                C26.053108,17.000000 21.621372,17.000000 17.293655,17.000000
                C17.293655,25.326441 17.293655,33.064789 17.293655,40.705162
                C25.329065,40.705162 33.067406,40.705162 40.703949,40.705162
                C40.703949,32.668549 40.703949,24.930183 40.703949,17.000000
                C37.431335,17.000000 34.451210,17.000000 30.484844,17.000000
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M153.000000,23.006311
                C153.000000,18.197165 153.000000,13.886424 153.000000,9.288725
                C166.280869,9.288725 179.350967,9.288725 192.711533,9.288725
                C192.711533,22.281399 192.711533,35.351490 192.711533,48.711788
                C179.718079,48.711788 166.647949,48.711788 153.000000,48.711788
                C153.000000,40.364697 153.000000,31.934708 153.000000,23.006311
            M164.651581,17.000019
                C163.046082,17.185017 160.880417,16.127213 160.952362,19.360548
                C161.110504,26.467806 161.001450,33.581009 161.001450,40.759789
                C169.214691,40.759789 176.952072,40.759789 184.757202,40.759789
                C184.757202,32.780029 184.757202,25.042671 184.757202,17.000000
                C178.220215,17.000000 171.921234,17.000000 164.651581,17.000019
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M9.000000,184.947723
                C9.000000,174.150894 9.000000,163.845840 9.000000,153.271332
                C22.317398,153.271332 35.387905,153.271332 48.730118,153.271332
                C48.730118,166.320343 48.730118,179.390793 48.730118,192.731552
                C35.676720,192.731552 22.606279,192.731552 9.000000,192.731552
                C9.000000,190.314026 9.000000,187.876755 9.000000,184.947723
            M36.377750,161.000000
                C29.955130,161.000000 23.532509,161.000000 17.333351,161.000000
                C17.333351,169.405548 17.333351,177.146393 17.333351,184.664017
                C25.410870,184.664017 33.152210,184.664017 40.999901,184.664017
                C40.999901,177.671921 40.827763,171.008942 41.076473,164.361694
                C41.191444,161.289032 39.956924,160.607071 36.377750,161.000000
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M192.965134,80.956573
                C192.930756,83.402283 192.930756,85.884644 192.930756,88.683487
                C187.748154,88.683487 182.561142,88.683487 177.184418,88.683487
                C177.184418,86.200233 177.184418,83.806335 177.184418,81.004486
                C182.276993,81.004486 187.203568,81.004486 192.601440,81.033295
                C193.072723,81.062096 192.999512,80.993240 192.965134,80.956573
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M136.930786,89.075859
                C139.398941,89.075859 141.867096,89.075859 144.667603,89.075859
                C144.667603,91.580109 144.667603,94.092552 144.667603,96.994957
                C142.364914,96.994957 140.102905,96.994957 137.382538,96.962929
                C136.924194,96.930901 136.997620,96.999954 137.001343,96.583916
                C137.026718,93.755241 137.048370,91.342598 137.034973,88.966202
                C136.999908,89.002441 136.930786,89.075859 136.930786,89.075859
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M128.924194,89.069382
                C128.924194,86.614944 128.924194,84.160507 128.924194,80.994904
                C131.411545,80.994904 133.783432,80.994904 136.612686,80.962463
                C137.045029,83.344231 137.020020,85.758453 136.962891,88.624268
                C136.930786,89.075859 136.999908,89.002441 136.583694,88.998688
                C133.753052,89.019753 131.338623,89.044563 128.924194,89.069382
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M193.042908,128.965607
                C190.604843,128.931213 188.130127,128.931213 185.327744,128.931213
                C185.327744,126.527809 185.327744,124.124069 185.327744,121.357384
                C187.564545,121.357384 190.074844,121.357384 192.995377,121.357384
                C192.995377,123.623215 192.995377,125.890099 192.966339,128.615082
                C192.937302,129.073196 193.006241,129.000000 193.042908,128.965607
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M177.037537,192.612274
                C174.657379,193.048386 172.244781,193.026718 169.381104,193.037552
                C168.930023,190.601959 168.930023,188.133850 168.930023,185.332947
                C171.578217,185.332947 174.090378,185.332947 177.005081,185.332947
                C177.005081,187.631866 177.005081,189.893188 177.037537,192.612274
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M16.962437,81.387848
                C21.997881,80.955040 27.065800,80.979980 32.604813,81.036926
                C33.075912,81.068924 33.002476,80.999992 32.998749,81.435547
                C32.973366,86.937386 32.951710,92.003662 32.930054,97.069946
                C32.930054,97.069946 33.000015,96.999992 32.562916,96.997520
                C24.393845,96.973404 16.661873,96.951767 8.929900,96.930122
                C8.929900,96.930122 9.000070,97.002487 9.034584,97.039215
                C9.069098,94.606857 9.069098,92.137764 9.069098,89.146194
                C11.577095,89.146194 14.106922,89.146194 16.994907,89.146194
                C16.994907,86.368965 16.994907,84.107285 16.962437,81.387848
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M8.962421,97.381142
                C16.661873,96.951767 24.393845,96.973404 32.597927,96.962570
                C33.070038,99.404495 33.070038,101.878891 33.070038,105.004951
                C25.254841,105.004951 17.564495,105.004951 9.402023,105.037415
                C8.951579,102.657303 8.973261,100.244736 8.962421,97.381142
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M120.924141,104.930771
                C120.924141,107.402290 120.924141,109.873810 120.924141,112.871330
                C123.590309,112.871330 126.111122,112.871330 129.004990,112.871330
                C129.004990,118.301491 129.004990,123.214645 129.037476,128.598877
                C123.939514,129.069946 118.809074,129.069946 113.308594,129.069946
                C113.308594,123.851540 113.308594,118.791496 113.308594,113.188095
                C107.784454,113.188095 102.590149,113.188095 97.005470,113.188095
                C97.005470,110.384254 97.005470,108.116158 97.003876,105.423965
                C97.002281,104.999863 96.929901,105.069878 97.402023,105.037415
                C105.606110,105.026604 113.338074,105.048256 121.033806,105.034866
                C120.997566,104.999840 120.924141,104.930771 120.924141,104.930771
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M97.042831,144.965683
                C94.592728,144.931290 92.105957,144.931290 89.309631,144.931290
                C89.309631,139.848846 89.309631,134.773102 89.309631,129.308090
                C91.495171,129.308090 93.897919,129.308090 96.684921,129.308090
                C96.684921,126.538086 96.684921,124.129791 96.684921,121.358047
                C99.569641,121.358047 102.084122,121.358047 104.806412,121.358047
                C104.806412,126.455620 104.806412,131.522690 104.806412,136.965637
                C102.234352,136.965637 99.826294,136.965637 96.995377,136.965637
                C96.995377,139.607239 96.995377,141.882126 96.966309,144.615143
                C96.937233,145.073288 97.006157,145.000076 97.042831,144.965683
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M33.400566,97.037460
                C32.951710,92.003662 32.973366,86.937386 32.962555,81.400528
                C35.398129,80.929962 37.866169,80.929962 40.855679,80.929962
                C40.855679,83.578468 40.855679,86.108513 40.855679,89.005768
                C43.631424,89.005768 45.892620,89.005768 48.576790,89.005920
                C48.999756,89.006065 48.926548,88.937134 48.926548,88.937134
                C48.952721,91.347527 48.978893,93.757927 49.037582,96.619102
                C44.003761,97.048248 38.937420,97.026611 33.400566,97.037460
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M80.962555,89.401001
                C83.398148,88.929962 85.866203,88.929962 88.855766,88.929962
                C88.855766,91.580887 88.855766,94.102402 88.855766,97.005516
                C91.631592,97.005516 93.892838,97.005516 96.577065,97.003998
                C97.000053,97.002487 96.929901,96.930115 96.962418,97.381134
                C96.973259,100.244736 96.951584,102.657303 96.929901,105.069878
                C96.929901,105.069878 97.002281,104.999863 97.039001,104.965408
                C91.961266,104.930946 86.846825,104.930946 80.995026,104.930946
                C80.995026,99.938515 80.995026,94.905281 80.962555,89.401001
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M49.387711,105.037537
                C48.951607,102.657372 48.973274,100.244774 48.962440,97.381096
                C51.398052,96.930023 53.866165,96.930023 56.667068,96.930023
                C56.667068,99.577194 56.667068,102.087624 56.667068,105.005089
                C54.368134,105.005089 52.106812,105.005089 49.387711,105.037537
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M70.871857,97.002106
                C72.110909,99.441856 72.884415,101.879799 73.808113,104.791138
                C70.268265,104.791138 67.883743,104.791138 65.247009,104.791138
                C65.247009,102.350723 65.247009,99.965630 65.247009,97.000290
                C66.928780,97.000290 68.667549,97.000290 70.871857,97.002106
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M49.037560,112.618935
                C46.601959,113.069977 44.133858,113.069977 41.332947,113.069977
                C41.332947,110.422585 41.332947,107.912125 41.332947,104.994911
                C43.631817,104.994911 45.893116,104.994911 48.612236,104.962463
                C49.048393,107.342644 49.026726,109.755272 49.037560,112.618935
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M49.034153,89.042725
                C49.068550,86.604683 49.068550,84.129982 49.068550,81.327675
                C51.472340,81.327675 53.876095,81.327675 56.642700,81.327675
                C56.642700,83.564598 56.642700,86.074928 56.642700,88.995369
                C54.376640,88.995369 52.109745,88.995369 49.384697,88.966248
                C48.926548,88.937134 48.999756,89.006065 49.034153,89.042725
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M137.000153,117.937683
                C137.000000,116.170242 137.000000,114.875259 137.000000,113.290627
                C139.562958,113.290627 141.944550,113.290627 144.669846,113.290627
                C144.669846,115.598869 144.669846,118.097916 144.669846,121.191368
                C142.188828,119.503006 138.161270,123.924843 137.000153,117.937683
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M128.960907,89.034805
                C131.338623,89.044563 133.753052,89.019753 136.618759,88.962448
                C137.048370,91.342598 137.026718,93.755241 137.037537,96.618958
                C134.657516,97.044868 132.244995,97.019699 129.416199,96.996048
                C128.999924,96.997574 129.070053,97.069984 129.037537,96.618912
                C129.026718,93.755264 129.048401,91.342690 129.070099,88.930115
                C129.070099,88.930115 128.997604,89.000237 128.960907,89.034805
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M128.965393,96.960869
                C128.930878,99.380501 128.930878,101.836845 128.930878,104.994949
                C126.586678,104.994949 124.213257,104.994949 121.381989,104.962860
                C120.924141,104.930771 120.997566,104.999840 121.001328,104.577560
                C121.005096,101.783501 121.005096,99.411728 121.005096,97.069984
                C124.160896,97.069984 126.615471,97.069984 129.070053,97.069984
                C129.070053,97.069984 128.999924,96.997574 128.965393,96.960869
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M152.969177,146.191620
                C152.996094,148.606018 152.996094,150.548920 152.996094,152.744553
                C150.369110,152.744553 147.982788,152.744553 145.295029,152.744553
                C145.295029,150.445312 145.295029,148.059555 145.295029,144.876343
                C147.752533,145.147491 150.347382,145.433807 152.969177,146.191620
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M97.034576,97.039200
                C97.069099,94.608467 97.069099,92.141022 97.069099,89.004913
                C102.071922,89.004913 107.102295,89.004913 112.604240,89.036949
                C113.075821,89.068985 113.002403,89.000061 112.998672,89.423912
                C112.994934,92.106163 112.994934,94.364563 112.994934,96.930115
                C107.394989,96.930115 102.162445,96.930115 96.929901,96.930115
                C96.929901,96.930115 97.000053,97.002487 97.034576,97.039200
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M113.387283,57.037552
                C112.930000,54.615372 112.930000,52.160736 112.930000,48.994904
                C115.411598,48.994904 117.783478,48.994904 120.612679,48.962448
                C121.070007,51.384644 121.070007,53.839291 121.070007,57.005096
                C118.588364,57.005096 116.216461,57.005096 113.387283,57.037552
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M96.962418,97.381134
                C102.162445,96.930115 107.394989,96.930115 112.994934,96.930115
                C112.994934,94.364563 112.994934,92.106163 112.962448,89.388924
                C117.996300,88.951729 123.062622,88.973373 128.599518,88.962570
                C129.048401,91.342690 129.026718,93.755264 129.037537,96.618912
                C126.615471,97.069984 124.160896,97.069984 121.005096,97.069984
                C121.005096,99.411728 121.005096,101.783501 121.037567,104.612587
                C113.338074,105.048256 105.606110,105.026604 97.402023,105.037415
                C96.951584,102.657303 96.973259,100.244736 96.962418,97.381134
            z"
        />
        <path
          fill="#FFFFFF"
          opacity="1.000000"
          stroke="none"
          d="
            M136.618988,64.962456
                C137.048370,67.342583 137.026703,69.755211 137.037552,72.618912
                C134.615433,73.069984 132.160797,73.069984 128.994904,73.069984
                C128.994904,70.588379 128.994904,68.216492 128.962463,65.387268
                C131.342667,64.951607 133.755295,64.973282 136.618988,64.962456
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M30.977962,17.000000
                C34.451210,17.000000 37.431335,17.000000 40.703949,17.000000
                C40.703949,24.930183 40.703949,32.668549 40.703949,40.705162
                C33.067406,40.705162 25.329065,40.705162 17.293655,40.705162
                C17.293655,33.064789 17.293655,25.326441 17.293655,17.000000
                C21.621372,17.000000 26.053108,17.000000 30.977962,17.000000
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M165.136917,17.000010
                C171.921234,17.000000 178.220215,17.000000 184.757202,17.000000
                C184.757202,25.042671 184.757202,32.780029 184.757202,40.759789
                C176.952072,40.759789 169.214691,40.759789 161.001450,40.759789
                C161.001450,33.581009 161.110504,26.467806 160.952362,19.360548
                C160.880417,16.127213 163.046082,17.185017 165.136917,17.000010
            z"
        />
        <path
          fill="#000000"
          opacity="1.000000"
          stroke="none"
          d="
            M36.863098,161.000000
                C39.956924,160.607071 41.191444,161.289032 41.076473,164.361694
                C40.827763,171.008942 40.999901,177.671921 40.999901,184.664017
                C33.152210,184.664017 25.410870,184.664017 17.333351,184.664017
                C17.333351,177.146393 17.333351,169.405548 17.333351,161.000000
                C23.532509,161.000000 29.955130,161.000000 36.863098,161.000000
            z"
        />
    </svg>
</template>

<script>
export default {
  name: "whatsAppQr",
};
</script>
